'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _datePicker = require('antd/lib/date-picker');

var _datePicker2 = _interopRequireDefault(_datePicker);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _connectField = require('uniforms/connectField');

var _connectField2 = _interopRequireDefault(_connectField);

var _filterDOMProps = require('uniforms/filterDOMProps');

var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _wrapField = require('./wrapField');

var _wrapField2 = _interopRequireDefault(_wrapField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Date_ = function Date_(props) {
    return (0, _wrapField2.default)(props, _react2.default.createElement(_datePicker2.default, (0, _extends3.default)({
        disabled: props.disabled,
        id: props.id,
        name: props.name,
        onChange: function onChange(value) {
            return props.onChange(value && value.toDate());
        },
        placeholder: props.placeholder,
        ref: props.inputRef,
        value: props.value && (0, _moment2.default)(props.value)
    }, (0, _filterDOMProps2.default)(props))));
};

Date_.displayName = 'Date';

Date_.defaultProps = {
    showTime: true,
    style: { width: '100%' }
};

exports.default = (0, _connectField2.default)(Date_, { ensureValue: false });


//////////////////
// WEBPACK FOOTER
// ./~/uniforms-antd/DateField.js
// module id = 284
// module chunks = 35783957827783 65974612472484